module.exports = __webpack_public_path__ + "img/Vector 77.96883736.svg";